import styled from '@emotion/styled';
import { NAVBAR_BREAKPOINT, PRODUCT_FRAME_GAP } from '../ProductFrame.styled';
export const StyledNavigation = styled.div `
	height: 100%;

	@media screen and (min-width: ${NAVBAR_BREAKPOINT}) {
		height: calc(100vh - (${PRODUCT_FRAME_GAP} * 2));
		margin-top: ${PRODUCT_FRAME_GAP};
		border-radius: 0 5px 5px 0;
		display: block;
	}
`;
//# sourceMappingURL=Navigation.styled.js.map